const Menu = [
  {
    path: "/",
    icon: "fa fa-th",
    title: "Inicio",
  },
  {
    path: "/solicitudes/disaan",
    icon: "fa fa-address-card",
    title: "Solicitudes",
  },
  {
    path: "/disaan/impresion_licencias",
    icon: "fa fa-print",
    title: "Impresión",
  },
];

export default Menu;
